// extracted by mini-css-extract-plugin
export default {"pagination":"dSGQv_Iq","paginationPage":"pniQqPUt","paginationPageWhite":"tr2mPKVp","paginationButton":"WDNFdqJo","paginationButtonOpasit":"gBMbmNCW"};